/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Donut Small (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_DONUT_SMALL_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0V0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88V88Z"
      fill="#F5F5F5"
    />
    <path
      className="svg-path-primary"
      clipRule="evenodd"
      d="M93.5648 39.8998V73.9498C93.5648 76.6998 95.8148 78.9498 98.5648 78.9498H132.515C135.715 78.9498 138.115 75.9998 137.415 72.8498C133.165 54.0498 118.415 39.2498 99.6648 34.9998C96.5148 34.2998 93.5648 36.6998 93.5648 39.8998ZM83.4148 39.8999V128.1C83.4148 131.3 80.4648 133.7 77.3648 133C55.0148 128 38.4148 107.95 38.4148 83.9999C38.4148 60.0499 55.0148 39.9999 77.3648 34.9999C80.4648 34.2999 83.4148 36.6999 83.4148 39.8999ZM93.5648 128.101V94.0505C93.5648 91.3005 95.8148 89.0505 98.6148 89.0005H132.565C135.715 89.0005 138.165 92.0005 137.465 95.1005C133.215 113.901 118.465 128.751 99.6648 133.001C96.5148 133.701 93.5648 131.301 93.5648 128.101Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <circle cx="132.5" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.833C118.636 107.833 107.833 118.636 107.833 132C107.833 145.364 118.636 156.167 132 156.167C145.364 156.167 156.167 145.364 156.167 132C156.167 118.636 145.364 107.833 132 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
  </svg>
);
